<template>
  <div class="test-container">
    <!-- 操作 -->
    <div style="overflow:hidden">
      <div>
        <span class="title">子系统列表</span>
        <el-button type="primary" @click="add">添加子系统</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      :key="tableKey"
      ref="multipleTable"
      v-loading="listLoading"
      stripe
      :data="list"
      tooltip-effect="dark"
      style="width: 100%"
      @cell-mouse-enter="operateShow"
      @cell-mouse-leave="operateClose"
    >
      <el-table-column :show-overflow-tooltip="true" fixed label="子系统序号" min-width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.sortNum }}</span>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="子系统名称" min-width="100px">
        <template slot-scope="scope">{{ emptyDeal(scope.row.name) }}</template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="业务类型" min-width="100px">
        <template slot-scope="scope">{{ businessStatus(scope.row.businessType).val }}</template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="工作台显示" min-width="100px">
        <template slot-scope="scope">{{ scope.row.isEnable?"是":"否" }}</template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="排序号" min-width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.sort?scope.row.sort:"0" }}</span>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" width="100px">
        <template slot-scope="scope" class="icon">
          <div class="icon">
            <i class="el-icon-change" @click="edit(scope.row.id)" />
            <i class="el-icon-dele" @click="delet(scope.row.id)" />
          </div>

        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="mt10">
      <el-pagination
        :current-page="pageInfo.currentPage"
        :page-sizes="pageInfo.pageSizeList"
        :page-size="pageInfo.limit"
        layout="total, prev, pager, next, jumper"
        :total="pageInfo.allCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 添加子系统 -->
    <div v-if="dialogVisibleAdd">
        <AddSystem :key="new Date().getTime()" :click-type="type" :edit-par="parmas" @returnResult="receiveData" />
    </div>
  </div>
</template>
<script>
import { getSystem, getLocalDictionary, deleteSystem } from '@/api/system'
import AddSystem from './components/AddSystem'

import { statusTrans, emptyTrans, sortDataList, nameTrans } from '@/api/dataTrans.js'
import { log } from 'util'
export default {
  components: {
    AddSystem
  },
  data() {
    return {
      list: [],
      listLoading: false,
      tableKey: 0,
      pageInfo: {
        limit: 10,
        allCount: 0,
        currentPage: 1,
        currentPageCount: 0,
        showEdit: false // 是否显示快捷编辑代码框
      },
      dialogVisibleAdd: false,
      dialogVisibleEdit: false,
      businessList: [{id:1,"name":"业务系统"},{id:2,"name":"支撑系统"},{id:3,"name":"基础服务"}],
      flag: false,
      type: '0',
      title: '添加子系统',
      parmas: null

    }
  },
  mounted() {
    // this.businessList = JSON.parse(window.localStorage.getItem('dictionary'))
    this.getSystemList()
  },

  methods: {
    getSystemList() {
      getSystem({
        pageNo: this.pageInfo.currentPage,
        pageSize: this.pageInfo.limit
      }).then(res => {
        if (res && res.code == 0) {
          this.list = sortDataList(res.data.items, this.pageInfo.currentPage)
          this.list = res.data.items
          this.pageInfo.allCount = res.data.total
        }
      })
    },
    // 删除
    removeSystem(data) {
      deleteSystem({ ids: data }).then(res => {
        if (res && res.code == 0) {
          this.getSystemList()
        }
      })
    },
    add() {
      this.dialogVisibleAdd = true
      this.type = '0'
      this.title = '添加子系统'
    },
    edit(data) {
      this.type = 1
      this.dialogVisibleAdd = true
      this.title = '编辑子系统'
      this.parmas = data
    },
    delet(data) {
      this.$confirm('确定删除 吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.removeSystem(data)
      }).catch(() => { })
    },
    emptyDeal(_val) {
      return emptyTrans(_val)
    },
    // 业务类型
    businessStatus(_val) {
      return nameTrans(_val, this.businessList)
    },
    // 显示操作按钮
    operateShow(row, column, cell, event) {
      event.path[1].cells[5].children[0].children[0].style.display = 'block'
    },
    operateClose() {
      event.path[1].cells[5].children[0].children[0].style.display = 'none'
    },
    receiveData() {
      this.dialogVisibleAdd = false
      this.getSystemList()
    },
    handleSizeChange(val) {
      this.pageInfo.limit = val
      this.pageInfo.currentPage = 1
      this.getSystemList()
    },
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val
      this.getSystemList()
    }
  }
}
</script>
<style lang="scss" scoped>
.operate {
  float: right;
  height: 24px;
}
[class^="el-icon-"] {
  margin-left: 16px;
  font-size: 20px;
}
.title {
  text-align: left;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
}
.el-button--primary {
  float: right;
}
.el-table {
  margin-top: 16px;
}
body .app-wrapper-new-style .test-container {
  padding: 16px 24px 100px 24px;
}
[class^="el-icon-"] {
  font-size: 16px;
  // margin-left: 24px;
}
[class^="el-icon-"]:hover {
  color: #FFA940;
}
.mt10 {
  margin-top: 24px !important;
  float: right;
}
.icon{
  display: none;
}
</style>
